export const OPEN_SUPPORT_CHAT_EVENT = 'autoqm:open-support-chat';

export function openSupportChat() {
  window.dispatchEvent(new Event(OPEN_SUPPORT_CHAT_EVENT));
}

// `?support_chat=open` on any non-admin page opens the widget on load.
export const SUPPORT_CHAT_QUERY_PARAM = 'support_chat';
